import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Introduction from "./components/Introduction";
import Industries from "./components/Industries";
import HowItWorks from "./components/HowItWorks";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

const App = () => {
  return (
    <div className="container">
      {/* Navbar Section */}
      <Navbar />
      {/* Hero Section */}
      <Hero />
      {/* Introduction Section */}
      <Introduction />
      {/* Industries Section */}
      <Industries />
      {/* HowItWorks Section */}
      <HowItWorks />
      {/* FAQ Section */}
      <Faq />
      {/* Footer Section */}
      <Footer />
    </div>
  );
};

export default App;